import { useSelector } from "react-redux";

import { ReduxState } from "../types";

export const useLanguage = () => {
  return useSelector((state: ReduxState) => state.dashboardApp.language);
};
